import React from "react";
import { clsxm } from "../../../utils/clxm/clxm";

export type Option = {
  label: string | React.ReactElement;
  value: string | number;
  selectedLabel?: string | React.ReactElement;
  isHeader?: boolean;
};

export type PSelectOption = {
  onSelect: (value: string | number) => void;
  option: Option;
  isActive: boolean;
  styles?: React.CSSProperties;
  getOptionCls?: (isActive: boolean) => string;
  onExpandedChange?: (expanded: boolean) => void; // Add this
};

export const OPTION_FONT_CLS =
  "Body-M-Regular 2xl:Body-L-Regular 4xl:Body-2XL-Regular";

export const SelectOption: React.FC<PSelectOption> = (props) => {
  const { onSelect, option, isActive, styles, getOptionCls, onExpandedChange } =
    props;

  const handleClick = () => {
    if (option.isHeader) {
      return;
    }
    onSelect(option.value);
    onExpandedChange?.(false);
  };

  if (option.isHeader) {
    return (
      <div key={option.value} style={styles} className="cursor-default">
        {option.label}
      </div>
    );
  }

  return (
    <div
      key={option.value}
      onClick={handleClick}
      style={styles}
      className={clsxm(
        "px-[10px] flex py-[10px] text-text-base gap-2 last:rounded-[0px_0px_8px_8px] cursor-pointer relative items-center hover:bg-neutral-4",
        OPTION_FONT_CLS,
        isActive && "border-l-[2px] border-l-border-button-primary",
        getOptionCls && getOptionCls(isActive)
      )}
    >
      {option.label}
    </div>
  );
};
